import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AiService {

  constructor(private httpClient: HttpClient, private apiService: ApiService) {}

  public prompt(type: string) {
    return this.httpClient.get(`${this.apiService.apiUrl()}/api/customer/ai/prompts`, 
      { params: new HttpParams({ fromObject: { 
        organization_id: `${this.apiService.organizationId()}`, 
        type: type 
      }}) 
    });
  }

  public assignmentSalesAssistant(chatId: string | null, prompt: string): Observable<any> {
    return this.httpClient.post(`${this.apiService.apiUrl()}/api/customer/ai/assignment`, {
      organization_id: this.apiService.organizationId(),
      chat_id: chatId,
      prompt: prompt
    });
  }

  public summariseSalesAssistant(chatId: string | null): Observable<any> {
    return this.httpClient.post(`${this.apiService.apiUrl()}/api/customer/ai/summarise`, {
      organization_id: this.apiService.organizationId(),
      chat_id: chatId
    });
  }

  public productSalesAssistant(chatId: string | null, assignentId: number, prompt: string): Observable<any> {
    return this.httpClient.post(`${this.apiService.apiUrl()}/api/customer/ai/products`, {
      organization_id: this.apiService.organizationId(),
      chat_id: chatId,
      assignment_id: assignentId,
      prompt: prompt
    });
  }

  public quantitySalesAssistant(chatId: string | null, assignmentId: number, productId: number, prompt: string): Observable<any> {
    return this.httpClient.post(`${this.apiService.apiUrl()}/api/customer/ai/quantity`, {
      organization_id: this.apiService.organizationId(),
      chat_id: chatId,
      assignment_id: assignmentId,
      product_id: productId,
      prompt: prompt
    });
  }
}
